import { Select, InputAdornment, MenuItem, Box } from '@mui/material';
import React, { useMemo } from 'react';
import { WebOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../hooks';
import { unknownGroup } from '../constants/Group';
import { setSubMenuItem } from '../middleware/menuThunk';
import { getSubMenu } from '../utils/menuUtils';

export const SubMenuSelect: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const { clientId } = useAppSelector((state) => state.clientData);
  const viewerState = useAppSelector((state) => state.viewer);
  const currentUserState = useAppSelector((state) => state.currentUser);
  const { group: { groupId, configurators = [] } = unknownGroup } = currentUserState;
  const { mainMenuItem, subMenuItem } = useAppSelector((state) => state.menu);
  const pricingState = useAppSelector((state) => state.pricing);

  const menuProps = useMemo(
    () => ({
      clientId,
      selectedGroupId: groupId,
      currentUserState,
      configurators,
      viewerState,
      pricingState,
      pricingEnableClientManaged: false,
    }),
    [clientId, groupId, currentUserState, configurators, viewerState, pricingState],
  );
  const options = useMemo(() => getSubMenu(menuProps, mainMenuItem, dispatch), [menuProps, mainMenuItem, dispatch]);

  if (!options.length || !subMenuItem) return null;
  return (
    <Box sx={{ pl: '18px', pr: configurators.length > 1 ? '18px' : '0px' }}>
      <Select
        value={subMenuItem}
        renderValue={(value: string) => options.find((opt) => opt.id === value)?.label(menuProps, t) || ''}
        onChange={(event) => {
          event.preventDefault();
          dispatch(setSubMenuItem(event.target.value));
        }}
        variant="standard"
        fullWidth
        disableUnderline
        startAdornment={
          <InputAdornment position="start">
            <WebOutlined color="primary" />
          </InputAdornment>
        }
        disabled={configurators.length <= 1}
        sx={{
          fontWeight: 600,
          '& .MuiSelect-icon': {
            color: (theme) => theme.palette.primary.main,
            display: configurators.length > 1 ? 'block' : 'none',
          },
          '& .MuiInputBase-input': {
            color: (theme) => theme.palette.primary.main,
            WebkitTextFillColor: (theme) => `${theme.palette.primary.main} !important`,
            pr: '0px',
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.label(menuProps, t)}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
